import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import {formatPrice} from '../helpers/helpers'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';
import LaborEdit from './LaborEdit';
import Modal from './Modal';
import ProductFields from './ProductFields';
import QuotationEdit from './QuotationEdit';

class QuotationTabEdit extends Component {

    constructor(){
        super();

        this.addInput = this.addInput.bind(this);
        this.remove = this.remove.bind(this);
        this.setList = this.setList.bind(this);
        this.setProductsLabor = this.setProductsLabor.bind(this);
        this.setLaborTotal = this.setLaborTotal.bind(this);
        this.handleCornerQty = this.handleCornerQty.bind(this);
        this.handleCornerPrice = this.handleCornerPrice.bind(this);
        this.handleCornerDis = this.handleCornerDis.bind(this);

        this.state ={
            customer : {},
            quotation : {},
            inputList : [],
            productsList : {},
            productsForLabor:{},
            totalLabor : {},
            totalLaborValue : 0,
            user: {},
            userId : "",
            cornerQty : 0,
            cornerPrice : 0,
            cornerDis : 0,
            cornerTotal : 0,
        }
        
    }
    componentDidMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        }); 

        var dbEdit = ref.child("Quotation").child(this.props.match.params.qid);
                    dbEdit.on("value",function(data){             
                        this.setState({
                            productsList : data.val().products,
                            quotation : data.val(),
                            customer : data.val().customer,
                            cornerQty : data.val().corners.cornerQty,
                            cornerPrice : data.val().corners.cornerPrice,
                            cornerDis : data.val().corners.cornerDis,
                            cornerTotal : data.val().corners.cornerTotal,
                            productsForLabor : data.val().labor

                        });

                    }.bind(this)); 

    }
    
    addInput(){
        let inputList = this.state.inputList;        
        let index = Date.now();
        this.setState({
            inputList : inputList.concat(<ProductFields key={index}  setList ={this.setList} index={index} remove={this.remove}/>)
        })
        //console.log(this.state.inputList)
    }

    remove(inputKey){
        let inputList = this.state.inputList
        let productsList = this.state.productsList
        let productsForLabor =  this.state.productsForLabor
        let totalLabor = this.state.totalLabor
        delete totalLabor[inputKey]
        delete productsList[inputKey]
        delete inputList[inputKey]
        delete productsForLabor[inputKey]
        

        let ids = Object.keys(this.state.totalLabor)

        let total = ids.reduce((prevTotal,key)=>{
            let value = this.state.totalLabor[key]
            return prevTotal + value.total
        },0)

        this.setState({
            totalLaborValue :total.toFixed(2)
        })
        
        this.setState({
            totalLabor,
            productsForLabor,
            inputList,
            productsList
        })
        
    }

    setList(index,prod,cat){

       let productsList = {...this.state.productsList}
        productsList[index]={
            category:cat,
            productId : prod
        };
        this.setState({inputList:[]})
        this.setState({productsList})
        
    }

    setProductsLabor(index,prodName,prodNumber,prodLaborPrice,discount,unit){
        let productsForLabor = {...this.state.productsForLabor}
            productsForLabor[index]={
                name : prodName,
                number : prodNumber,
                price : prodLaborPrice,
                discount :discount,
                unit : unit

            }
        this.setState({
            productsForLabor 
        })

    }
    
    setLaborTotal(index,data,discount,prodName,prodNumber,prodLaborPrice,unit){
        let totalLabor = {...this.state.totalLabor}
            totalLabor[index]={
                total : data,
                name : prodName,
                number : prodNumber,
                price : prodLaborPrice,
                discount :discount,
                unit : unit
            }
        this.setState({
            totalLabor 
        })
    }
    handleCornerQty(e){
        this.setState({
            cornerQty : e.target.value
        })
        var total = this.state.cornerPrice * e.target.value;
        
        if(this.state.cornerDis > 0){
            var dis = this.state.cornerDis / 100;          
            var cornerTotal = total - (total * dis)

            this.setState({
                cornerTotal : cornerTotal
            })
        }else{
            this.setState({
                cornerTotal : total
            })
        }

    }
    handleCornerPrice(e){
        this.setState({
            cornerPrice : e.target.value
        })

        var total = this.state.cornerQty * e.target.value;
        
        if(this.state.cornerDis > 0){
            var dis = this.state.cornerDis / 100;          
            var cornerTotal = total - (total * dis)

            this.setState({
                cornerTotal : cornerTotal
            })
        }else{
            this.setState({
                cornerTotal : total
            })
        }
    }
    handleCornerDis(e){
        this.setState({
            cornerDis : e.target.value
        })
        
        var total = this.state.cornerQty * this.state.cornerPrice;
        
        if(this.state.cornerDis > 0){
            var dis = e.target.value / 100;          
            var cornerTotal = total - (total * dis)

            this.setState({
                cornerTotal : cornerTotal
            })
        }else{
            this.setState({
                cornerTotal : total
            })
        }
    }
    
    componentDidUpdate(prevProps,prevState){
        if(prevState.totalLabor !== this.state.totalLabor){
            
            let ids = Object.keys(this.state.totalLabor)
            let total = ids.reduce((prevTotal,key)=>{
                let value = this.state.totalLabor[key]
                return prevTotal + value.total
            },0)
            var tot = total + this.state.cornerTotal;
            this.setState({
                totalLaborValue :tot.toFixed(2)
            })
        }
        if(prevState.cornerTotal !== this.state.cornerTotal){
            
            let ids = Object.keys(this.state.totalLabor)
            let total = ids.reduce((prevTotal,key)=>{
                let value = this.state.totalLabor[key]
                return prevTotal + value.total
            },0)
            var tot = total + this.state.cornerTotal;
            this.setState({
                totalLaborValue :tot.toFixed(2)
            })
        }
    }

    render() {
            
        return (
            <div id="page-wrapper">                
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar/>
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Edit Quotation" />
                            <div className="block">
                                <div>
                                <div className="row">
                                    <div className="col-md-6">
                                        {/*<button className="btn btn-primary marginLeft3px" data-toggle="modal" data-target="#AddProducts">Manage Product</button> */}                                       
                                    </div>
                                </div>
                                {/*<!-- Working Tabs Block -->*/}
                                <div className="block full">
                                    {/*<!-- Working Tabs Content -->*/}
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/*<!-- Block Tabs -->*/}
                                            <div >
                                                {/*<!-- Block Tabs Title -->*/}
                                                <div className="block-title">
                                                    <ul className="nav nav-tabs" data-toggle="tabs">
                                                        <li className="active"><a href="#example-tabs2-activity1">Add Quotation</a></li>
                                                        <li><a href="#example-tabs2-profile1">Labor</a></li>
                                                    </ul>
                                                </div>
                                                {/*<!-- END Block Tabs Title -->*/}

                                                {/*<!-- Tabs Content -->*/}
                                                <div className="tab-content">
                                                    <div className="tab-pane active" id="example-tabs2-activity1">
                                                        {/**********<!-- Quotation -->**********/}
                                                       <QuotationEdit productsList ={this.state.productsList} setProductsLabor ={this.setProductsLabor}
                                                            totalLaborValue ={this.state.totalLaborValue} totalLabor = {this.state.totalLabor} user={this.state.user} userId={this.state.userId} 
                                                            quotation={this.state.quotation} customer={this.state.customer}  quotId={this.props.match.params.qid}
                                                            setList = {this.setList} remove={this.remove} cornerQty = {this.state.cornerQty}
                                                            cornerPrice = {this.state.cornerPrice} cornerDis = {this.state.cornerDis} cornerTotal = {this.state.cornerTotal}/>
                                                           
                                                    </div>
                                                    <div className="tab-pane" id="example-tabs2-profile1">
                                                        {/**********<!-- Labor -->**********/}
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-left forRoofType">Product Name</th>
                                                                    <th className="text-center forLengthSize">Number</th>
                                                                    <th className="text-center forLengthSize">Price</th>
                                                                    <th className="text-center forLengthSize">Discount</th>
                                                                    <th className="text-center forUnitType">Total</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="forInputArea">
                                                                {

                                                                    this.state.productsForLabor &&                                     
                                                                        Object.keys(this.state.productsForLabor).map(function (key){                                                                              
                                                                                
                                                                                let list = this.state.productsForLabor[key]                                                                                                                             
                                                                                return <LaborEdit ref={key} key={key} index={key} product ={list} 
                                                                                        setLaborTotal={this.setLaborTotal}  />     
                                                                        }.bind(this))
                                                                    
                                                                }
                                                                {console.log(this.state.productsForLabor) }   
                                                                <tr>
                                                                <td>Corners</td>                                        
                                                                <td><input type="text" className="form-control"  name="cornerQty" ref={input => this.cornerQty = input} value={this.state.cornerQty} onChange={this.handleCornerQty}/></td>
                                                                <td><input type="text" className="form-control"  name="cornerPrice" ref={input => this.cornerPrice = input} value={this.state.cornerPrice} onChange={this.handleCornerPrice}/></td>
                                                                <td><input type="text" className="form-control"  name="cornerDis" ref={input => this.cornerDis = input} value={this.state.cornerDis} onChange={this.handleCornerDis}/></td>
                                                                <td><p>{formatPrice(this.state.cornerTotal)}</p></td>
                                                                </tr>
                                                                <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td className="grandTotalQ">Total</td>
                                                                <td className="grandTotal">{formatPrice(this.state.totalLaborValue)}</td>
                                                                </tr>                                    
                                                            </tbody>
                                                        </table>                                                        
                                                    </div>
                                                </div>
                                                {/*<!-- END Tabs Content -->*/}
                                            </div>
                                            {/*<!-- END Block Tabs -->*/}
                                        </div>
                                    </div>
                                    {/*<!-- END Working Tabs Content -->*/}
                                </div>
                                {/*<!-- Working Tabs Block -->*/}
                             </div>
                            </div>
                        <Footer />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default QuotationTabEdit;



// WEBPACK FOOTER //
// ./src/components/QuotationTabEdit.js